interface NumberCellProps {
  text: string | number;
}

const NumberCell = ({ text }: NumberCellProps) => <div className="text-center w-50">{text}</div>;

export default NumberCell;
